/**
 * Help Me Choose — luxury styling consultation form.
 * Progressive enhancement: the form works via a plain Shopify contact POST
 * without JS; this script only adds the card interactions, conditional
 * WhatsApp fields, upload preview and loading/success polish.
 */
(function () {
  var root = document.querySelector('[data-help-me-choose]');
  if (!root) return;

  var MAX_FILE_BYTES = 10 * 1024 * 1024;

  /* ---------- Step 1: multi-select request-type cards ---------- */
  var optionCards = root.querySelectorAll('.help-me-choose__option-card');
  var optionSummary = root.querySelector('[data-option-summary]');

  function syncOptionSummary() {
    if (!optionSummary) return;
    var selected = [];
    optionCards.forEach(function (card) {
      var input = card.querySelector('input');
      if (input && input.checked) selected.push(input.value);
    });
    optionSummary.value = selected.join(', ');
  }

  /* Handle the toggle ourselves instead of relying on the browser's
     native label -> checkbox click forwarding, which has proven
     unreliable on touch devices for this layout (scrollable row,
     label text that changes weight/width on selection). Cancelling
     the click's default action and flipping `checked` directly gives
     one deterministic toggle per tap, every time. */
  optionCards.forEach(function (card) {
    var input = card.querySelector('input');
    if (!input) return;
    card.addEventListener('click', function (event) {
      event.preventDefault();
      input.checked = !input.checked;
      card.classList.toggle('is-selected', input.checked);
      syncOptionSummary();
      input.blur();
    });
  });

  /* ---------- Step 2: consultation method + conditional fields ---------- */
  var methodCards = root.querySelectorAll('.help-me-choose__method-card');
  var conditional = root.querySelector('[data-whatsapp-conditional]');
  var conditionalInputs = conditional ? conditional.querySelectorAll('input, select') : [];

  function updateMethod() {
    var checkedCard = null;
    var checkedValue = '';
    methodCards.forEach(function (card) {
      var input = card.querySelector('input');
      var isChecked = !!(input && input.checked);
      card.classList.toggle('is-selected', isChecked);
      if (isChecked) {
        checkedCard = card;
        checkedValue = input.value;
      }
    });

    var isWhatsapp = checkedValue === root.dataset.whatsappValue;

    if (conditional) {
      conditional.classList.toggle('is-visible', isWhatsapp);
      conditional.setAttribute('aria-hidden', String(!isWhatsapp));
      conditionalInputs.forEach(function (field) {
        if (field.hasAttribute('data-required-when-whatsapp')) {
          field.required = isWhatsapp;
        }
      });
    }

    root.querySelectorAll('[data-upload-note]').forEach(function (note) {
      var showFor = note.getAttribute('data-upload-note');
      note.classList.toggle('is-visible', showFor === (isWhatsapp ? 'whatsapp' : 'email'));
    });
  }

  methodCards.forEach(function (card) {
    var input = card.querySelector('input');
    if (input) input.addEventListener('change', updateMethod);
  });
  updateMethod();

  /* ---------- Step 5: preferred time pills ---------- */
  root.querySelectorAll('.help-me-choose__radio-pill').forEach(function (pill) {
    var input = pill.querySelector('input');
    if (!input) return;
    input.addEventListener('change', function () {
      var group = pill.closest('.help-me-choose__radio-group');
      if (group) {
        group.querySelectorAll('.help-me-choose__radio-pill').forEach(function (p) {
          p.classList.remove('is-selected');
        });
      }
      pill.classList.toggle('is-selected', input.checked);
    });
  });

  /* ---------- Step 4: drag-and-drop photo upload ---------- */
  var dropzone = root.querySelector('[data-dropzone]');
  var fileInput = root.querySelector('[data-file-input]');
  var preview = root.querySelector('[data-preview]');
  var previewThumb = root.querySelector('[data-preview-thumb]');
  var previewName = root.querySelector('[data-preview-name]');
  var previewRemove = root.querySelector('[data-preview-remove]');
  var fileNameField = root.querySelector('[data-file-name-field]');
  var fileError = root.querySelector('[data-file-error]');

  function setFile(file) {
    if (!file) return;
    fileError.textContent = '';

    var isImage = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isImage) {
      fileError.textContent = 'Please choose a JPG or PNG file.';
      return;
    }
    if (file.size > MAX_FILE_BYTES) {
      fileError.textContent = 'That photo is larger than 10 MB — please choose a smaller file.';
      return;
    }

    if (fileNameField) fileNameField.value = file.name;

    var reader = new FileReader();
    reader.onload = function (event) {
      if (previewThumb) previewThumb.src = event.target.result;
      if (previewName) previewName.textContent = file.name;
      if (preview) preview.classList.add('is-visible');
    };
    reader.readAsDataURL(file);
  }

  function clearFile() {
    if (fileInput) fileInput.value = '';
    if (fileNameField) fileNameField.value = '';
    if (preview) preview.classList.remove('is-visible');
    if (previewThumb) previewThumb.src = '';
    fileError.textContent = '';
  }

  if (dropzone && fileInput) {
    fileInput.addEventListener('change', function () {
      setFile(fileInput.files && fileInput.files[0]);
    });

    ['dragenter', 'dragover'].forEach(function (evtName) {
      dropzone.addEventListener(evtName, function (event) {
        event.preventDefault();
        dropzone.classList.add('is-dragover');
      });
    });

    ['dragleave', 'drop'].forEach(function (evtName) {
      dropzone.addEventListener(evtName, function (event) {
        event.preventDefault();
        dropzone.classList.remove('is-dragover');
      });
    });

    dropzone.addEventListener('drop', function (event) {
      var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
      if (file) {
        fileInput.files = event.dataTransfer.files;
        setFile(file);
      }
    });
  }

  if (previewRemove) {
    previewRemove.addEventListener('click', function (event) {
      event.preventDefault();
      clearFile();
    });
  }

  /* ---------- Submit: loading state + WhatsApp hand-off ---------- */
  var form = root.querySelector('form');
  var submitButton = root.querySelector('[data-submit-button]');

  if (form && submitButton) {
    form.addEventListener('submit', function () {
      submitButton.classList.add('is-loading');

      var checkedMethod = root.querySelector('input[name="contact[Preferred contact method]"]:checked');
      var isWhatsapp = checkedMethod && checkedMethod.value === root.dataset.whatsappValue;
      var waNumber = root.dataset.whatsappNumber;

      if (isWhatsapp && waNumber) {
        var name = (root.querySelector('#HelpMeChoose-name') || {}).value || '';
        var message = (root.querySelector('#HelpMeChoose-message') || {}).value || '';
        var text = 'Hi Hijabique! I just submitted a styling consultation request'
          + (name ? ' as ' + name : '') + '.'
          + (message ? ' ' + message : '')
          + ' I would love your help choosing the perfect color and fabric, and I have a photo of my outfit to share here.';
        var waLink = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(text);
        window.open(waLink, '_blank', 'noopener');
      }
    });
  }

  /* ---------- Success state focus ---------- */
  var successStatus = root.querySelector('[data-success-status]');
  if (successStatus) {
    successStatus.setAttribute('tabindex', '-1');
    successStatus.focus();
    successStatus.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
})();
